import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { UILayout, UIText, UIIcon } from 'bora-material-ui'

export const IconBeforeField = ({ icon, showPlus, plusColor = '#dedede' }, { muiTheme }) => (
  <Fragment display-if={!muiTheme.ids.DisableIconInputField}>
    <UILayout
      display-if={icon}
      zIndex={1}
      top="50%"
      left="10px"
      width="22px"
      height="auto"
      shrink="0"
      margin="0 14px 0 0"
    >
      <UILayout center j-flex-center width="22px">
        <UIIcon type={icon} fill="black" left="0px" />
      </UILayout>
    </UILayout>

    <UIText display-if={showPlus} color={plusColor} margin="0 8px 0 0">
      +
    </UIText>
  </Fragment>
)

IconBeforeField.propTypes = {
  icon: PropTypes.string.isRequired,
  plusColor: PropTypes.string.isRequired,
  showPlus: PropTypes.bool.isRequired,
}

IconBeforeField.contextTypes = {
  muiTheme: PropTypes.any,
}
